import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { handleNewTabLink } from '../../services/Utils';

// Redux
import { resizeParent } from '../../services/Utils'
import { configure, getConfiguration } from '../../actions/Settings'
import { getPCOGroups } from './redux/pco.actions';

// Components
import Spinner from '../Spinner';
import SelectMenu from '../SelectMenu';
import SearchInput from '../SearchInput';
import TwentySeventeenGroupCard from '../Groups/Cards/TwentySeventeenGroupCard';
import EmphasisGroupCard from '../Groups/Cards/EmphasisGroupCard';
import DefaultCard from '../Groups/Cards/DefaultCard';
import TCCGroupsMap from '../Groups/TCCGroupsMap';
import TCCGroupsOpenMap from '../Groups/TCCGroupsOpenMap';

const cleanString = (str = null) => {
    if (!str) return null;
    return str.toLowerCase();
}

const PCOGroupCard = (props) => {

    const handleClick = (e) => {
        if (props.attributes.public_church_center_web_url) {
            handleNewTabLink(e, '_blank', props.attributes.public_church_center_web_url);
        }

    }

    return (
        <article className="card group" onClick={handleClick}>

            <a href={props.attributes.public_church_center_web_url} target="_top">
                <div className="image">
                    <img alt={props.attributes.name} src={props.attributes.header_image.medium} />
                </div>
                <div className="content">

                    <div className="center-wrap">

                        <h6 className="title" dangerouslySetInnerHTML={{ __html: props.attributes.name }}></h6>

                        {props.attributes && props.attributes.schedule && (<div className="when" dangerouslySetInnerHTML={{ __html: props.attributes.schedule }}></div>)}

                    </div>

                </div>
            </a>

        </article>
    );

}


export const PCOGroups = (props) => {

    const dispatch = useDispatch();

    // Filters
    const [type, setType] = useState(props.type);
    const [area, setArea] = useState(props.area);
    const [when, setWhen] = useState(props.when);
    const [showMap, setShowMap] = useState((props.map === 'open_map') ? true : false);
    const [loading, setLoading] = useState(true);
    const [searchString, setSearchString] = useState(null);
    const [groups, setGroups] = useState([]);
    const [displayGroups, setDisplayGroups] = useState([]);

    // Options
    const [typeOptions, setTypeOptions] = useState([]);
    const [areaOptions, setAreaOptions] = useState([]);
    const [whenOptions, setWhenOptions] = useState([]);

    // Labels
    const typeLabel = (props.typelabel) ? props.typelabel : "Type";
    const areaLabel = (props.arealabel) ? props.arealabel : "Area";
    const whenLabel = (props.whenlabel) ? props.whenlabel : "When";

    // Defaults
    const limit = (props.limit) ? parseInt(props.limit) : null;
    const showFilters = (props.showfilters === 'false') ? false : true;
    const site = props.site;
    const zoom = (props.zoom) ? parseInt(props.zoom) : 11;

    // Store
    const fullSettings = useSelector(state => state.Settings)
    const fullGroups = useSelector(state => state.Groups);

    const parseResult = (res) => {



        // Day
        let whenArray = [
            { value: '', title: 'All', id: 'all' },
            { value: 'monday', title: 'Mondays', id: 'monday' },
            { value: 'tuesday', title: 'Tuesdays', id: 'tuesday' },
            { value: 'wednesday', title: 'Wednesdays', id: 'wednesday' },
            { value: 'thursday', title: 'Thursdays', id: 'thursday' },
            { value: 'friday', title: 'Fridays', id: 'friday' },
            { value: 'saturday', title: 'Saturdays', id: 'saturday' },
            { value: 'sunday', title: 'Sundays', id: 'sunday' },
        ];
        let typeKeys = {};
        let areaKeys = {};

        let gs = [];

        // Groups
        if (res.Groups) {
            gs = Object.keys(res.Groups).map((id, index) => {
                const g = res.Groups[id];
                if (g.attributes.enrollment_open != true) return;
                if (!g.attributes.public_church_center_web_url) return;
                if (g.relationships.location.data) {
                    g.Location = res.Location[g.relationships.location.data.id];
                    areaKeys[g.relationships.location.data.id] = true;
                }
                if (g.relationships.group_type.data) {
                    g.GroupType = res.GroupType[g.relationships.group_type.data.id];
                    typeKeys[g.relationships.group_type.data.id] = true;
                }
                return g;
            });
        }

        // Types
        let typeArray = [{ value: '', title: 'All', id: 'all' }];
        if (res.GroupType) {
            const types = Object.keys(res.GroupType).map((id, index) => {
                const item = res.GroupType[id];
                if (!typeKeys[id]) return;
                typeArray.push({ value: id, title: item.attributes.name, id: id })
            })
        }

        // Location
        let areaArray = [{ value: '', title: 'All', id: 'all' }];
        if (res.Location) {
            const areas = Object.keys(res.Location).map((id, index) => {
                const item = res.Location[id];
                if (!areaKeys[id]) return;
                areaArray.push({ value: id, title: item.attributes.name, id: id })
            })
        }



        // Set Data
        setTypeOptions(typeArray);
        setAreaOptions(areaArray);
        setWhenOptions(whenArray);
        setGroups(gs);
        setLoading(false);

        // Default Filter
        filterGroups();
    }

    const filterGroups = () => {

        const args = { searchString, type, when, area };

        if (fullGroups.ui !== 'success') return;
        let f = {};
        const filteredGroups = Object.keys(fullGroups.groups.Groups).map((group_id, index) => {
            const group = fullGroups.groups.Groups[group_id];
            if (group.attributes.enrollment_open != true) return;
            if (!group.attributes.public_church_center_web_url) return;
            if (group.relationships.location.data) group.Location = fullGroups.groups.Location[group.relationships.location.data.id];
            if (group.relationships.group_type.data) group.GroupType = fullGroups.groups.GroupType[group.relationships.group_type.data.id];

            // Search String
            let searchable = '';
            searchable += (group.attributes.name) ? group.attributes.name.toLowerCase() + ' ' : '';
            searchable += (group.attributes.description) ? group.attributes.description.toLowerCase() + ' ' : '';
            searchable += (group.Location && group.Location.attributes.full_formatted_address) ? group.Location.attributes.full_formatted_address.toLowerCase() + ' ' : '';
            searchable += (group.Location && group.Location.attributes.name) ? group.Location.attributes.name.toLowerCase() + ' ' : '';
            searchable += (group.attributes.schedule) ? group.attributes.schedule.toLowerCase() + ' ' : '';
            searchable += (group.attributes.location_type_preference) ? group.attributes.location_type_preference.toLowerCase() + ' ' : '';
            searchable += (group.GroupType && group.GroupType.attributes && group.GroupType.attributes.name) ? group.GroupType.attributes.name.toLowerCase() + ' ' : '';


            // Apply Filters
            if (searchString && (searchable.indexOf(searchString.toLowerCase())) < 0) return null;
            if (type && (group.GroupType && group.GroupType.id !== type)) return null;
            if (area && (group.Location && group.Location.id !== area)) return null;
            if (when && (group.attributes.schedule.toLowerCase().indexOf(when) <= -1)) return null;

            // Convert to TCC Form
            group.title = group.attributes.name;
            group.when = group.attributes.schedule;
            group.time = '';
            if (group.Location) {
                group.address = {
                    lat: group.Location.attributes.latitude,
                    lng: group.Location.attributes.longitude,
                    address: group.Location.attributes.full_formatted_address
                }
                group.address_settings = "show"
            }
            group.image_thumb = group.attributes.header_image.medium;
            group.ID = group_id;
            group.url = group.attributes.public_church_center_web_url;

            f[group_id] = group;

            return group;
        });

        // Sort By Name
        let groupsAsArray = Object.values(f);
        groupsAsArray.sort((a, b) => (a.title > b.title) ? 1 : -1)
        setGroups(groupsAsArray);
        resizeParent();
    }

    // On Mount
    useEffect(() => {

        // Configure
        dispatch(configure(site))

        // Load Configuration
        dispatch(getConfiguration());

        // Resize
        resizeParent();

    }, [])

    // Settings: Ready
    useEffect(() => {
        if (!fullSettings.site) return;
        if (fullGroups.ui === 'loading') return;
        const args = {
            type,
            area,
            when,
            page: 1
        }

        // Load Groups
        if (!fullGroups.groups) dispatch(getPCOGroups(args))

    }, [fullSettings])


    // Groups: Ready
    useEffect(() => {
        // Guard: Loading
        if (fullGroups.ui !== 'success') return;

        // Parse Result
        parseResult(fullGroups.groups);

    }, [fullGroups])



    // Apply Filters
    useEffect(() => {
        filterGroups();
    }, [searchString, type, when, area]);


    const renderCards = () => {

        if (!groups) return (<div></div>);
        let count = 0;

        return groups.map(item => {

            if (limit && count >= limit) return;
            count++;
            return (
                <CSSTransition key={item.id} timeout={200} classNames="listtransition">
                    <PCOGroupCard {...item} key={item.id} />
                </CSSTransition>
            )

        })
    }


    // Loading
    if (loading) return (<Spinner />);

    return (
        <div data-component-type="TCCGroups" className="pushpay-groups-container">

            {/************ NAVIGATION BAR *************/}
            {showFilters && (
                <div className="NavigationBar">

                    <SearchInput name="search" placeholder="Search" onChange={(value) => setSearchString(value)} />
                    {!props.type && (<SelectMenu name="type" title={typeLabel} onChange={(e) => setType(e.target.value)} options={typeOptions} />)}
                    {!props.when && (<SelectMenu name="when" title={whenLabel} onChange={(e) => setWhen(e.target.value)} options={whenOptions} />)}
                    {!props.area && (<SelectMenu name="area" title={areaLabel} onChange={(e) => setArea(e.target.value)} options={areaOptions} />)}
                    <button onClick={() => setShowMap(!showMap)}>
                        <span className="icon icon-location"></span>
                    </button>
                </div>
            )}
            <TransitionGroup>
                {showMap && (
                    <CSSTransition key={1} timeout={200} classNames="map-transition">
                        <div className="groups-map">
                            <TCCGroupsOpenMap pco="true" zoom={zoom} groups={groups} center={fullSettings.address} />
                        </div>
                    </CSSTransition>
                )}
            </TransitionGroup>
            <div className="groups-results">
                <div className="posts-loop">
                    <TransitionGroup>{renderCards()}</TransitionGroup>
                </div>
            </div>
        </div>
    )
}


